import { useStore } from '@app/store'
import type { UserData } from '@app/types'

const staticObject = {}

type UseStoreCurrentUser = () => UserData | Record<string, never>
const useStoreCurrentUser: UseStoreCurrentUser = () => useStore.use.currentUser() || staticObject

export default useStoreCurrentUser
